import { useEffect, useState } from 'react';
import { WC_2026 } from '@punditxi/shared';
import { countdownTo } from '../lib/utils';

export function TournamentMarquee() {
  const [parts, setParts] = useState(() => countdownTo(WC_2026.TOURNAMENT_START));

  useEffect(() => {
    const id = setInterval(() => setParts(countdownTo(WC_2026.TOURNAMENT_START)), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="relative overflow-hidden rounded-2xl bg-bg-darker border border-border-base">
      {/* Host nation tri-stripe banner */}
      <div className="host-stripe h-2 w-full" />

      <div className="relative px-5 py-7 text-center">
        <div className="font-display-alt text-xs uppercase tracking-[0.4em] text-text-faint">
          FIFA World Cup
        </div>
        <div className="font-display text-5xl uppercase tracking-tight text-text-base mt-1 leading-none">
          Predict the
          <br />
          Tournament
        </div>

        {/* Skewed red year banner */}
        <div className="my-5 inline-block -skew-x-12 bg-usa-red px-5 py-2">
          <span className="font-display text-4xl tracking-wider text-white skew-x-12 inline-block">
            2026
          </span>
        </div>

        <div className="font-display-alt text-xs uppercase tracking-widest text-text-dim mt-3">
          Kickoff in
        </div>
        <div className="mt-2 grid grid-cols-4 gap-2">
          <CountdownCell label="D" value={parts.days} />
          <CountdownCell label="H" value={parts.hours} />
          <CountdownCell label="M" value={parts.minutes} />
          <CountdownCell label="S" value={parts.seconds} />
        </div>
      </div>

      <div className="host-stripe h-2 w-full" />
    </div>
  );
}

function CountdownCell({ label, value }: { label: string; value: number }) {
  return (
    <div className="bg-bg-card rounded-lg border border-border-base py-2">
      <div className="font-mono text-2xl font-extrabold text-trophy-gold tabular-nums">
        {String(value).padStart(2, '0')}
      </div>
      <div className="font-display-alt text-[10px] uppercase tracking-widest text-text-faint">
        {label}
      </div>
    </div>
  );
}
